function state() {
  return {
    snackbar: {},
    modal: [],
    pageInfo: {},
    profileMenu: {},
    itemListingOrganisation: {},
    uploadProgress: 0,
    routeViewKey: {},
    pageLoadingFirstTime: null,
    routeOnChanged: null,
  };
}

export default state;
